import React, { useState } from 'react';

const AboutSection = () => {
  const [selectedCard, setSelectedCard] = useState('mision');

  const isSelected = (type) => selectedCard === type;

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              ¿Quiénes somos?
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              ADVANCE Consortium es la apuesta de Bogotá para cerrar brechas de capital humano y 
              fomentar el acceso a la educación postsecundaria y superior.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Trabajamos de la mano con Atenea para crear oportunidades reales de crecimiento 
              profesional y personal para todos los bogotanos, especialmente aquellos que más lo necesitan.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              {[
                { id: 'mision', title: 'Misión', text: 'Democratizar el acceso a la educación de calidad' },
                { id: 'vision', title: 'Visión', text: 'Ser líderes en transformación educativa' }
              ].map((card) => (
                <div
                  key={card.id}
                  onClick={() => setSelectedCard(card.id)}
                  className={`cursor-pointer p-6 rounded-xl shadow transition-all duration-300 transform ${
                    isSelected(card.id)
                      ? 'bg-gradient-to-br from-red-100 to-orange-100 scale-105 shadow-lg'
                      : 'bg-gray-100 hover:scale-105 hover:shadow-md'
                  }`}
                >
                  <h3 className={`text-3xl font-bold mb-2 ${
                    isSelected(card.id) ? 'text-red-600' : 'text-gray-700'
                  }`}>
                    {card.title}
                  </h3>
                  <p className="text-gray-700">{card.text}</p>
                </div>
              ))}
            </div>

            <div className="flex items-center space-x-6">
              <a
                href="https://agenciaatenea.gov.co/nosotros/que-es-atenea"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative px-8 py-4 text-white rounded-full font-semibold overflow-hidden transform hover:scale-105 transition-all"
                style={{
                  background: 'linear-gradient(to right, #d51231, #a00e27)'
                }}
              >
                <span className="relative z-10">Más sobre Atenea</span>
                <div className="absolute inset-0 bg-gradient-to-r from-red-800 to-red-900 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
              </a>
              <img 
                src="/images/atenea-logo.png" 
                alt="Atenea" 
                className="h-16 w-auto"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2 relative">
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600" 
                alt="Estudiantes colaborando" 
                className="rounded-2xl shadow-2xl"
              />
              <div
                className="absolute -bottom-6 -right-6 text-white p-6 rounded-2xl shadow-xl"
                style={{
                  background: 'linear-gradient(to right, #d51231, #a00e27)'
                }}
              >
                <h4 className="text-2xl font-bold">20+ Aliados</h4>
                <p>Instituciones educativas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
